<template>
  <div class="gray_wrapper">
    <div class="view_form_data" ref="print">
      <el-row>
        <el-col v-for="item in fields" :key="item.id" :span="item.span || 24">
          <DataItem :info="item" :value="datas[item.id]" />
        </el-col>
      </el-row>
      <table class="history_table" v-if="isFlow">
        <thead>
          <tr>
            <th>节点名称</th>
            <th>审核时间</th>
            <th>操作人</th>
            <th>操作结果</th>
            <th>审核意见</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in historyList" :key="item.id">
            <td>{{ item.nodeName }}</td>
            <td>{{ item.endTime }}</td>
            <td>{{ item.assigneeName }}</td>
            <td>{{ getResultStr(item.appResult) }}</td>
            <td>{{ item.appMsg }}</td>
          </tr>
        </tbody>
      </table>
      <div class="no-print print_con">
        <el-button type="primary" @click="printInfo">打印</el-button>
      </div>
    </div>
  </div>
</template>

<script>

const resultMap = {
  cancel:"取消",
  no:"驳回",
  yes:"通过"
};


import api from "@api";
import DataItem from "./DataItem";
export default {
  name: "view_form_data",
  components: { DataItem },
  data() {
    return {
      isFlow: false,
      formId: "",
      dataId: "",
      datas: {},
      fields: [],
      historyList: [],
    };
  },
  mounted() {
    this.formId = this.$route.query.formId;
    this.dataId = this.$route.query.businessId || this.$route.query.dataId;
    if(this.dataId.includes(",")){
      this.dataId = this.dataId.split(",")[1];
    };
    this.loadData();
    if (this.$route.query && this.$route.query.instanceId) {
      this.isFlow = true;
      this.loadHistory();
    }
  },
  methods: {
    printInfo() {
      setTimeout(() => {
        this.$print(this.$refs.print); // 使用
      }, 0);
    },
    loadData() {
      this.$successAjax(
        api.data + "/" + this.formId + "/" + this.dataId,
        {},
        {
          method: "get",
        }
      ).then(({ data }) => {
        // console.log(data);
        window.document.title = data.config.formName;
        this.datas = data.datas;
        this.$nextTick(() => {
          this.fields = data.list;
        });
      });
    },
    loadHistory() {
      this.$successAjax(
        api.getProcessHistory +
          "?instanceId=" +
          this.$route.query.instanceId,
        {},
        {
          method: "get",
        }
      ).then(({ data }) => {
        this.historyList = data;
      });
    },
    getResultStr(flag){
      if(!flag){
        return "";
      };
      return resultMap[flag];
    }
  },
};
</script>

<style lang="scss">
.history_table {
  table-layout: fixed;
  width: 100%;
  font-size: 12px;
  overflow: hidden;
  border-collapse: collapse;

  th {
    background: #f2f5fa;
    padding: 8px 0;
  }

  td {
    padding: 6px 0;
    color: #515a6e;
    border-bottom: 1px solid #e8eaec;
  }

  th,
  td {
    text-align: left;
    padding-left: 8px;
    padding-right: 8px;
  }
}
.print_con {
  margin-top: 20px;
  text-align: center;
}
</style>